import { render, staticRenderFns } from "./ModalSignUpFranchisee.vue?vue&type=template&id=b61de4fe&scoped=true&"
import script from "./ModalSignUpFranchisee.vue?vue&type=script&lang=js&"
export * from "./ModalSignUpFranchisee.vue?vue&type=script&lang=js&"
import style0 from "./ModalSignUpFranchisee.vue?vue&type=style&index=0&id=b61de4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61de4fe",
  null
  
)

export default component.exports